module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-11"
  }, [_vm._v("Copyright © 2014")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-11"
  }, [_vm._v("By Barbara Sillery")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-11"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-7"
  }, [_vm._v("The word “Pelican” and the depiction of a pelican are")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-7"
  }, [_vm._v("trademarks of Pelican Publishing Company, Inc., and are")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-7"
  }, [_vm._v("registered in the U.S. Patent and Trademark Office.")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-12"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-13"
  }, [_vm._v("Sillery, Barbara.")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-13"
  }, [_vm._v("The haunting of Cape Cod and the Islands / by Barbara Sillery.")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-13"
  }, [_vm._v("pages cm")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-13"
  }, [_vm._v("ISBN 978-1-4556-1993-1 (pbk. : alk. paper) — ISBN 978-1-4556-1994-8 (e-book) 1. Ghosts—Massachusetts—Cape Cod. 2. Haunted places—Massachusetts—Cape Cod. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-13"
  }, [_vm._v("BF1472.U6S5345 2014")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-13"
  }, [_vm._v("133.109744’9—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-13"
  }, [_vm._v("2014025692")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT"
  }, [_vm._v("Photographs by Barbara Sillery unless otherwise indicated")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-11"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "",
      "src": "image1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-14"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-11"
  }, [_vm._v("Published by Pelican Publishing Company, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-15"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.92em"
    }
  }, [_vm._v("1000 Burmaster Street, Gretna, Louisiana 70053")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-0-Basic-paragraph-NO-INDENT_para-style-override-7"
  }, [_vm._v("To Glinda Schafer, an ext"), _c('a', {
    attrs: {
      "id": "Anchor"
    }
  }), _vm._v("raordinary artist and an extraordinary friend. Thank you for all the years of being there for me.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 63
// module chunks = 0